import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import isPropValid from '@emotion/is-prop-valid';

import { Text } from '../components';

const LOCKOUT_COPY_WIDTH = '282px';
const LOCKOUT_TITLE_GAP = '10px';

const filterLockout = {
  shouldForwardProp: (prop) => isPropValid(prop) && prop !== 'lockout',
};

const containerBaseStyles = ({ theme }) => css`
  padding: 0 ${theme.spacings.exa};
`;

const lockoutContainerStyles = ({ lockout, theme }) =>
  lockout &&
  css`
    max-width: ${LOCKOUT_COPY_WIDTH};
    margin: 0 auto;
    padding: ${theme.spacings.giga} 0 0;
  `;

const Container = styled('div', filterLockout)(containerBaseStyles, lockoutContainerStyles);

const textContainerBaseStyles = ({ theme }) => css`
  color: ${theme.colors.b500};
  text-align: center;
`;

const textContainerMarginStyles = ({ margin }) =>
  margin &&
  css`
    margin-top: 0;
    margin-bottom: 0;
  `;

const TextContainer = styled('div')(textContainerBaseStyles, textContainerMarginStyles);

const titleOverrideBaseStyles = () => css`
  p {
    line-height: 22px !important;
  }
`;

const lockoutTitleStyles = ({ lockout }) =>
  lockout &&
  css`
    p {
      font-size: 18px;
      line-height: 22px !important;
      margin-bottom: ${LOCKOUT_TITLE_GAP};
    }
  `;

const TitleOverride = styled('div', filterLockout)(titleOverrideBaseStyles, lockoutTitleStyles);

const textOverrideBaseStyles = () => css`
  p {
    line-height: 19px !important;
  }
`;

const lockoutTextStyles = ({ lockout, theme }) =>
  lockout &&
  css`
    p {
      font-size: 15px;
      line-height: 18px !important;
      font-weight: ${theme.fontStack.default.weight};
      letter-spacing: -0.225px;
      margin: 0;
    }
  `;

const TextOverride = styled('div', filterLockout)(textOverrideBaseStyles, lockoutTextStyles);

const QuizHeader = ({ title, text, lockout }) => (
  <Container lockout={lockout} data-testid={lockout ? 'stq-lockout-header' : undefined}>
    <TextContainer>
      <TitleOverride lockout={lockout}>
        <Text size='zetta' bold noMargin={lockout}>
          {title}
        </Text>
      </TitleOverride>
      {text && (
        <TextContainer margin>
          <TextOverride lockout={lockout}>
            <Text size='giga' noMargin={lockout}>
              {text}
            </Text>
          </TextOverride>
        </TextContainer>
      )}
    </TextContainer>
  </Container>
);

QuizHeader.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
  lockout: PropTypes.bool,
};

QuizHeader.defaultProps = {
  title: 'Please solve the math problem below to continue',
  lockout: false,
};

export default QuizHeader;
